export function extractYoutubeId(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  if (/^[\w-]{11}$/.test(trimmed)) return trimmed;
  const watch = trimmed.match(/youtube\.com\/watch\?v=([\w-]{11})/);
  if (watch) return watch[1];
  const short = trimmed.match(/youtu\.be\/([\w-]{11})/);
  if (short) return short[1];
  const embed = trimmed.match(/youtube\.com\/embed\/([\w-]{11})/);
  if (embed) return embed[1];
  const shorts = trimmed.match(/youtube\.com\/shorts\/([\w-]{11})/);
  if (shorts) return shorts[1];
  return '';
}

export function toYoutubeEmbedUrl(url) {
  const id = extractYoutubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : '';
}

export function newYoutubeVideo(url = '', title = '') {
  return {
    id: `yt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    url: String(url || '').trim(),
    title: String(title || '').trim(),
  };
}

export function normalizeYoutubeVideos(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item, i) => {
      if (typeof item === 'string') {
        return { id: `yt_${i}`, url: item.trim(), title: '' };
      }
      if (!item || typeof item !== 'object') return null;
      const url = String(item.url || item.link || item.src || item.href || '').trim();
      if (!url) return null;
      return {
        id: item.id || `yt_${i}`,
        url,
        title: String(item.title || item.label || item.name || '').trim(),
      };
    })
    .filter(Boolean);
}

export function persistableYoutubeVideos(videos) {
  return normalizeYoutubeVideos(videos)
    .filter((v) => v.url)
    .map((v) => ({
      id: v.id,
      url: v.url,
      title: v.title || '',
    }));
}
